module.exports = __webpack_public_path__ + "img/delivery.685d1d75.svg";